import React from 'react'

import {Props} from './types'

const Vehicle: React.FC<Props> = props => (
  <svg height="32" viewBox="0 0 56 56" width="32" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M56 28c0 15.452-12.548 28-28 28S0 43.452 0 28 12.548 0 28 0s28 12.548 28 28z" fill="#fc0" />
    <path d="M8 22h8v8H8v-8zm8 8h8v8h-8v-8zm8-8h8v8h-8v-8zm8 8h8v8h-8v-8zm8-8h8v8h-8v-8z" fill="#000" />
  </svg>
)

export default Vehicle
